import { Injectable } from '@angular/core';
import { GfTranslateService } from '../../../../services/core.translate.service';

import * as _ from 'lodash';
@Injectable()
export class TeamReportHelper {

    constructor(
        private gfTranslateService: GfTranslateService,
    ) { }

    getSortFields() {
        return {
            'unixName': this.gfTranslateService.translate('User')
        };
    }
    getAnyFilterObj() {
        return { id: '', label: this.gfTranslateService.translate("Any"), defaultSelected: true };
    }
    getCustomFilterObj() {
        return { id: null, label: this.gfTranslateService.translate("Custom"), defaultSelected: false };
    }
    getYesNoElements() {
        return [
            { id: 'N', label: this.gfTranslateService.translate('No'), defaultSelected: true },
            { id: 'Y', label: this.gfTranslateService.translate('Yes'), defaultSelected: false }
        ];
    }
    getElementFromProject(p) {
        return {
            id: p.id,
            label: p.unixName + ': ' + p.name,
            defaultSelected: false
        };
    }
    getProjectList(list) {
        return [this.getAnyFilterObj()]
            .concat(_.map(list, this.getElementFromProject));
    }
    getDateRangeElements() {
        return [
            this.getAnyFilterObj(),
            { id: '-7 days', label: this.gfTranslateService.translate("This Week") },
            { id: '-15 days', label: this.gfTranslateService.translate("Last 15 days") },
            { id: '-30 days', label: this.gfTranslateService.translate("Last 30 days") },
            { id: '-60 days', label: this.gfTranslateService.translate("Last 60 days") },
            { id: '-90 days', label: this.gfTranslateService.translate("Last 90 days") },
            { id: '-365 days', label: this.gfTranslateService.translate("Last year") },
        ];
    }
    getBaseFilters(projectList) {
        var any = this.getAnyFilterObj();
        var yesNo = this.getYesNoElements();

        // Only include org-level if there are child projects
        var org = [];

        if (!_.isEmpty(projectList)) {
            org = [
                { alias: "subprojects", fieldName: this.gfTranslateService.translate("Include Subprojects"), value: yesNo[0], fieldType: 1, isExtraField: false, fieldElements: yesNo },
                { alias: "subproject", fieldName: this.gfTranslateService.translate("Subproject"), value: any, fieldType: 1, isExtraField: false, fieldElements: this.getProjectList(projectList) },
            ];
        }

        var ret = org.concat([
            { alias: "user", fieldName: this.gfTranslateService.translate("User"), value: any, fieldType: 4, isExtraField: false },
            { alias: "startDate", fieldName: this.gfTranslateService.translate("Start Date"), value: '', fieldType: 9, isExtraField: false },
            { alias: "endDate", fieldName: this.gfTranslateService.translate("End Date"), value: '', fieldType: 9, isExtraField: false },
            { alias: "rangeDate", fieldName: this.gfTranslateService.translate("Date Range"), value: any, fieldType: 1, isExtraField: false, fieldElements: this.getDateRangeElements() },
        ]);

        return ret;
    }
    getSelectedElement(filter, stateParams) {
        var val = _.get(stateParams, filter.alias, false) || '';
        var elem = _.find(filter.fieldElements, { id: val });
        if (!elem) {
            elem = _.find(filter.fieldElements, { defaultSelected: true });
        }
        return elem;
    }
    setFiltersFromStateParams(filters, stateParams) {
        return _.map(
            filters,
            function (f) {
                switch (f.fieldType) {
                    case 1: // list
                        f.value = this.getSelectedElement(f, stateParams);
                        break;

                    default: // text/other
                        f.value = _.get(stateParams, f.alias, '');
                        break;
                }
                return f;
            }
        );
    }
}
